import React from 'react';
import { EmptyState } from '@packages/ui/layout/EmptyState';
import { Stack } from '@packages/ui/layout';
import { Spinner } from '@packages/ui/primitives';

interface BlockLoadStateProps {
  isLoading: boolean;
  error?: string | null;
  errorTitle?: string;
  children: React.ReactNode;
}

export function BlockLoadState({
  isLoading,
  error,
  errorTitle = 'Unable to load content',
  children,
}: BlockLoadStateProps): JSX.Element {
  if (isLoading) {
    return (
      <Stack align='center' justify='center' style={{ padding: '48px 16px' }}>
        <Spinner size='lg' semanticId='blockLoadSpinner' />
      </Stack>
    );
  }

  if (error) {
    return (
      <EmptyState
        icon='error'
        title={errorTitle}
        description={error}
        semanticId='blockLoadError'
      />
    );
  }

  return <>{children}</>;
}
